import { Fixed, FixedProps } from '@packages/layout/lib/Blocks/Fixed';
import { MountPoint, MountPointProps } from '@packages/portals/lib/MountPoint';
import { createMemo } from '@packages/react';
import React from 'react';

export type FixedMountPointProps = MountPointProps & FixedProps;

export const FixedMountPoint = createMemo<FixedMountPointProps>((props) => <MountPoint {...props} />, {
    displayName: 'FixedMountPoint',
    defaultProps: {
        component: Fixed,
    },
});
